import { Grid } from '@mantine/core';
import React from 'react';
import { Notifications } from '../components';

export default function NotificationsPage(){
    const listRef = React.useRef<any>();

    return <>

        <Grid>
            <Grid.Col xs={12} md={8}>
                <Notifications.List ref={listRef} />
            </Grid.Col>
        </Grid>
    </>
}
